export default "__VITE_ASSET__935568e8__$_?nuxt_component=async__"